import { Card } from '@bancobarigui/barihaus';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { RejectionRate } from '../types';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface RejectionRateChartProps {
  data: RejectionRate[];
  loading?: boolean;
  title?: string;
}

export function RejectionRateChart({ data, loading = false, title = 'Taxa de rejeição por prestadora' }: RejectionRateChartProps) {
  const chartData = {
    labels: data.map(item => item.provider),
    datasets: [
      {
        label: 'Taxa de Rejeição (%)',
        data: data.map(item => item.rate),
        backgroundColor: '#ff4d4f',
        borderRadius: 4,
      },
    ],
  };

  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return `${context.parsed.x.toFixed(1).replace('.', ',')}%`;
          },
        },
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: true,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title={title} bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '400px' }}>
          <Bar data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
